import "./index.scss"
import React from "react"
import { Link } from "gatsby"
import { getImage, GatsbyImage } from "gatsby-plugin-image"

export default function ArticleImage({ component }) {
  const {
    image
  } = component

  return (
    <div className="article__image-wrapper">
      <GatsbyImage
        image={getImage(image.gatsbyImageData)}
        className="article__image"
        alt=""
        />
    </div>
  )
}
